// extracted by mini-css-extract-plugin
module.exports = {"container":"completed-form-page-module__container--DChmL","message":"completed-form-page-module__message--TMhHN","goToMyAccount":"completed-form-page-module__goToMyAccount--ffJgW"};